interface TutorialStep {
  step: number;
  title: string;
  content: string;
  type: "text" | "image" | "video";
}

interface TutorialStepsProps {
  steps: TutorialStep[];
}

export const TutorialSteps = ({ steps }: TutorialStepsProps) => {
  return (
    <div className="space-y-8 mb-8">
      {steps.map((step) => (
        <div key={step.step} className="border rounded-lg p-6 max-w-[768px] mx-auto">
          <h3 className="text-lg font-semibold mb-4">
            Step {step.step}: {step.title}
          </h3>
          <p className="mb-4">{step.content}</p>
          {step.type === "image" && (
            <div className="aspect-video bg-muted rounded-lg" />
          )}
          {step.type === "video" && (
            <div className="aspect-video bg-muted rounded-lg" />
          )}
        </div>
      ))}
    </div>
  );
};